export default __webpack_public_path__ + "static/favicon-1024x1024-with-padding-5eacc09469f87d38513eec6b8dd16e69.png";